// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryDownloadState__icon-bba907 {
  color: var(--addition-50);
  padding: 0 4px;
  height: 40px;
  min-width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryHeader/MediaGalleryDownloadState/MediaGalleryDownloadState.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AACF","sourcesContent":[".icon {\n  color: var(--addition-50);\n  padding: 0 4px;\n  height: 40px;\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `MediaGalleryDownloadState__icon-bba907`
};
module.exports = ___CSS_LOADER_EXPORT___;
